import { HttpErrorResponse } from '@angular/common/http';
import {
  AfterViewInit,
  Component,
  Inject,
  OnInit,
  ViewChild
} from '@angular/core';
import {
  AbstractControl,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogConfig,
  MatDialogRef
} from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { ITipoFormulario } from '@app/modules/formulario/model/tipo_formulario.model';
import { TipoFormularioService } from '@app/modules/formulario/service/tipo_formulario.service';
import {
  ConfirmDialogComponent,
  ConfirmDialogData
} from '@app/shared/components';
import { Utils } from '@app/shared/helpers/utils';
import { Dialog } from 'primeng/dialog';
import {
  CustomValidators,
  ErroMessages,
  IErroMessages,
  ScreenService,
  TokenService
} from 'viggo-sistemas-core-web';

@Component({
  templateUrl: './fast-tipo-formulario.component.html',
  styleUrls: ['./fast-tipo-formulario.component.scss'],
  providers: [TipoFormularioService]
})
export class FastTipoFormularioComponent implements OnInit, AfterViewInit {
  @ViewChild('fastTpForm') fastTpForm: Dialog;
  public form: UntypedFormGroup;

  loading = false;

  displayMessage = {
    descricao: {
      duplicate: 'Já existe um tipo de formulário com essa descrição!',
      required: 'A descricão é obrigatório',
      maxlength: 'Não pode ter mais de 60 caracteres',
      isEmptyValue: 'Valor inválido: remova os espaços em branco!'
    },
    codigo: {
      required: 'O código é obrigatório',
      maxlength: 'O código deve conter no máximo 6 caracteres.'
    }
  };

  constructor(
    public dialogRef: MatDialogRef<FastTipoFormularioComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ITipoFormulario,
    protected fb: UntypedFormBuilder,
    public entityService: TipoFormularioService,
    public screenService: ScreenService,
    public tokenService: TokenService,
    public matSnackBar: MatSnackBar,
    public matDialog: MatDialog,
    public router: Router
  ) {}

  ngAfterViewInit(): void {
    if (this.screenService.detectDeviceInfo().isMobile)
      this.fastTpForm.maximize();
  }

  ngOnInit() {
    this.form = this.fb.group({
      descricao: [
        '',
        [
          Validators.required,
          Validators.maxLength(60),
          CustomValidators.isEmptyValue()
        ]
      ]
    });
    this.validateForm();
  }

  onSubmit() {
    if (this.form.valid) {
      this.loading = true;
      const { ...rest } = this.form.value;
      var entity = { domain_id: this.tokenService.getDomain().id, ...rest };
      entity = Utils.trimAttributes(entity);
      this.entityService.insert(entity).subscribe(
        tp_form => {
          if (tp_form) {
            this.matSnackBar.open(
              `Nova tipo de formulário cadastrado com sucesso.`,
              'X',
              {
                duration: 2000,
                horizontalPosition: 'right',
                verticalPosition: 'top',
                panelClass: ['msg-success']
              }
            );
            this.dialogRef.close(tp_form);
          }
        },
        (err: HttpErrorResponse) => {
          this.displayError(err);
          this.loading = false;
        },
        () => {
          this.loading = false;
        }
      );
    }
  }

  markAllControlsAsDirty() {
    Object.keys(this.form.controls).forEach(controlKey => {
      controlKey = String(controlKey);
      const control = this.form.get(controlKey);
      if (!control || control.valid) return;
      control.markAsDirty();
    });
  }

  validateForm() {
    this.form.markAllAsTouched();
    this.markAllControlsAsDirty();
  }

  actionFnCheckEntityExist(control: AbstractControl) {
    Utils.checkIfValueExist(
      control,
      this.entityService,
      'descricao',
      this.tokenService.getDomain().id
    );
  }

  displayError(err: HttpErrorResponse, showDefaultMsg = false) {
    const errorMsg = new ErroMessages({
      route: this.router.url,
      router: this.router,
      matSnackBar: this.matSnackBar,
      httpError: err,
      showDefaultMsg: showDefaultMsg,
      loginService: null,
      tokenService: this.tokenService,
      dialogComponent: ConfirmDialogComponent,
      matDialog: this.matDialog,
      dialogData: {
        config: {
          data: {
            title: 'Aviso - Erro ao realizar operação',
            bodyMessage: err.error,
            icon: 'pi pi-fw pi-info-circle text-orange-500 mb-2 mr-2',
            singleBtn: true
          } as ConfirmDialogData,
          disableClose: true,
          width: '500px'
        } as MatDialogConfig<any>
      }
    } as IErroMessages);
    errorMsg.showMessageObject(err.error);
    // errorMsg.checkError();
  }
}
